import React, { useEffect, useState } from 'react';

import apiCategories from '../../../service/apiCategories';
import TableHeader from '../TableHeader';
import ModalWindow from '../../../components/ModalWindow';
import Button from '../../../components/Button';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import './Table.sass';
import AddCategories from '../AddCategories';

const Table = () => {
  const [ categoryes, setCategoryes ] = useState([]);
  const [ activeAdd, setActiveAdd ] = useState(false);

  useEffect(() => {
    const api = new apiCategories();
    api.getCategories().then(res => setCategoryes(res));
  }, []);

  const updateAdd = (list) => setCategoryes(list);
  const deleteItem = (id) => {
    const api = new apiCategories();
    api.deleteCategory(id).then(res => setCategoryes(res))
  };

  const closeAdd = () => setActiveAdd(false);

  const expListItem = categoryes.map(item => {
    return (
      <div className="regions langs row" key={item.id}>
        <div className="col-10 regions-item">
          <div className="ml-4">
            {item.title}
          </div>
        </div>
        <div
          onClick={() => deleteItem(item.id)}
          className="col-2 regions-item text-center d-flex justify-content-center">
          <div className="text-center">
            <DeleteForeverIcon />
          </div>
        </div>
      </div>
    );
  });

  return (
    <div className="table d-flex flex-column">
      {activeAdd ?
        <ModalWindow close={closeAdd}>
          <AddCategories
            update={updateAdd}
            close={closeAdd}/>
        </ModalWindow> : null}

      <div className="ml-auto mb-4">
        <Button text="Добавить" onClick={() => setActiveAdd(true)} />
      </div>

      <div className="table-content shadow-box">
        <TableHeader />
        <div className="table-content-border"></div>
        {expListItem}
      </div>
    </div>
  );
};

export default Table;
